<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Account Cancellation</ion-title>
    </ion-toolbar>
</ion-header>


<ion-content>
    <ion-list>

        <ion-item color="secondary" ion-text-wrap>
            <ion-label color="light" ion-text-wrap>
                Only cancel your membership if you are absolutely certain that you no longer
                wish to use state of the art technology to manage your shuttle department,
                to maintain departmental control, to have better employees, to minimize the
                number of things your customers complain about all while lowering operating
                costs.<br /><br />
                Simply call the phone number below and tell us you want to cancel and the
                reason for your cancellation. As always, we will be happy to assist you and
                we will miss serving you.
            </ion-label>
        </ion-item>

        <ion-item>
            <div>
                <strong>Account Number</strong><br />
                {{vm.accountNumber}}
            </div>
        </ion-item>
        <ion-item>
            <div>
                <strong>Company Hours</strong><br />
                {{vm.companyHours}}
            </div>
        </ion-item>
        <ion-item>
            <div>
                <strong>Phone Number</strong><br />
                {{vm.phoneNumber}}
            </div>
        </ion-item>
    </ion-list>
</ion-content>